import React, { forwardRef } from "react";
import SelectInput from "../../select-input";
import TextInput from "../../text-input";
import {
  BankTransferProps,
  RefsBankTransfer,
} from "../types/bank-transfer.types";

export interface BankTransferWithForwardRef
  extends React.ForwardRefExoticComponent<
    BankTransferProps & React.RefAttributes<() => RefsBankTransfer>
  > {}

export const BankTransfer = forwardRef<
  () => RefsBankTransfer,
  BankTransferProps
>(
  (
    {
      bankSelect,
      customerNameInput,
      routingNumberInput,
      accountNumberInput,
    }: BankTransferProps,
    ref
  ): React.ReactElement => {
    const {
      bankSelectRef,
      customerNameInputRef,
      routingNumberInputRef,
      accountNumberInputRef,
    } = (ref as any)?.() || {};
    return (
      <>
        <SelectInput {...bankSelect} ref={bankSelectRef} />
        <TextInput {...customerNameInput} ref={customerNameInputRef} />
        <TextInput {...routingNumberInput} ref={routingNumberInputRef} />
        <TextInput {...accountNumberInput} ref={accountNumberInputRef} />
      </>
    );
  }
) as BankTransferWithForwardRef;

BankTransfer.displayName = "BankTransfer";
